import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { Breadcrumb } from '../../../shared/breadcrumbs/breadcrumbs';
import { NORMATIVES_PATHS } from '../normatives';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-normatives-page',
  templateUrl: './normatives-page.component.html',
  styleUrls: ['./normatives-page.component.scss'],
  standalone: false,
})
export class NormativesPageComponent implements OnInit, OnDestroy {
  public NORMATIVES_PATHS = NORMATIVES_PATHS;
  public normativesBreadcrumbs: Breadcrumb[] = [{ text: 'Нормативы', url: null }];
  public tabActiveManual: string = NORMATIVES_PATHS.work_standards;

  private destroyed$ = new Subject<void>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private breadcrumbsService: BreadcrumbsService
  ) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.normativesBreadcrumbs);
    this.tabActiveManual = this.getActiveTabFromUrl();

    // Кнопки «Назад»/«Вперёд» меняют адрес и содержимое router-outlet,
    // но саму обёртку с вкладками не пересоздают — ngOnInit больше не сработает.
    // Поэтому подсветку вкладки синхронизируем с адресом на каждой навигации
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => {
        this.tabActiveManual = this.getActiveTabFromUrl();
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  // Клик по табе, а также первичная активация табы компонентом app-tabs
  public onTabChange(changeTabObj) {
    let changedTab = changeTabObj && changeTabObj.currentTab;

    if (!changedTab || changedTab.id === this.getActiveTabFromUrl()) {
      return;
    }

    this.tabActiveManual = changedTab.id;
    this.router.navigate([changedTab.id], { relativeTo: this.activatedRoute });
  }

  private getActiveTabFromUrl(): string {
    let currentUrl = this.router.url.split('?')[0].split('#')[0];
    let currentTab = currentUrl.slice(currentUrl.lastIndexOf('/') + 1);

    return currentTab === NORMATIVES_PATHS.speed_standards ? NORMATIVES_PATHS.speed_standards : NORMATIVES_PATHS.work_standards;
  }
}
